import { render, staticRenderFns } from "./LoginHead.vue?vue&type=template&id=1418b581&scoped=true"
import script from "./LoginHead.vue?vue&type=script&lang=js"
export * from "./LoginHead.vue?vue&type=script&lang=js"
import style0 from "./LoginHead.vue?vue&type=style&index=0&id=1418b581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1418b581",
  null
  
)

export default component.exports